import {DataObject} from "./DataObject";

export class PaperType  implements DataObject {
  public ID: number;
  public name: string;
  public gsm: number;
  public caliper: number;
  public opacity: number;
  public manufacturer: string;
  public comment: string | null;
  public colorName: string;
  public color: string;
  public brightness: number;
  public presentationColor: string;
  public lastUpdate: Date;

  constructor ( obj ) {
    this.ID = 0;
    this.name = '';
    this.gsm = 0;
    this.caliper = 0;
    this.opacity = 0;
    this.manufacturer = '';
    this.comment = null;
    this.colorName = '';
    this.color = '';
    this.brightness = 0;
    this.presentationColor = '';
    this.lastUpdate = new Date();

    if ( obj && obj['ID']) {
      this.ID = obj['ID'];
    }
    this.update(obj);
  }

  public getId() {
    return this.ID;
  }
  public getOrderValue() {
    return this.ID;
  }

  update (obj: any) {
    if (obj) {
      for (const prop of Object.keys(obj)) {
        if (obj[prop] !== null && (prop !== 'ID') && ( typeof obj[prop] === 'string' || typeof obj[prop] === 'number' || typeof obj[prop] === 'boolean' || obj[prop] instanceof String || obj[prop] instanceof Boolean || obj[prop] instanceof Number || obj[prop] instanceof Date )) {
          this[prop] = obj[prop];
        }
      }
    }
  }
}
